/**
 * Port of Java's `String.hashCode`.
 * @see https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 * @param obj
 * @returns {number} hash code of JSON string representation of given object
 */
export const hashCode = (obj: any): number => {
    let hash = 0
    if (obj === undefined) {
        return hash
    }
    const s = JSON.stringify(obj)
    for (let i = 0; i < s.length; i++) {
        const char = s.charCodeAt(i)
        // exceptions for speed; hashing methodology needn't be understandable
        /* tslint:disable:no-bitwise no-magic-numbers */
        hash = ((hash << 5) - hash) + char
        hash = hash & hash
        /* tslint:disable:no-bitwise no-magic-numbers */
    }
    return hash
}
